import { render } from "./App.vue?vue&type=template&id=09357b04"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "D:\\documenti\\Lavoro\\Niemit\\com.niemit.cortebenedetto\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__